// OrderTypeSwitch.jsx
import React from 'react';

export const OrderTypeSwitch = ({ orderType, onSwitch, isLoading }) => {
  if (orderType !== 'dine_in' && orderType !== 'pick_up') return null;

  return (
    <div
      className="inline-flex truncate text-sm px-4 pt-2 sm:px-4"
      onClick={onSwitch}
    >
      <p className="text-gray-500 truncate group-hover:text-gray-900">
        Switch to {orderType === 'dine_in' ? 'Pick Up' : 'Dine In'}
      </p>
    </div>
  );
};
